module.exports = __webpack_public_path__ + "static/media/carrorama-banner-main-cut.577ebc16.jp2";